<script>
import _ from 'lodash'
import EberFiles from '@/components/EberFiles'
import VuePhotoSwipe from '@/components/VuePhotoSwipe'
import EberPhotoViewer from "../../../../VuePhotoSwipe/src/eber-photo-viewer";
export default {
  name: 'CommonFileList',
  components: {
    EberPhotoViewer,
    VuePhotoSwipe,
    EberFiles
  },
  props: {
    files: {
      type: Array,
      default () {
        return []
      }
    },
    keyName: {
      type: String,
      default: 'id'
    },
    disabled: {
      type: Boolean,
      default: true
    },
    enableDrag: {
      type: Boolean,
      default: false
    },
    shareButtons: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      vpsoptions: {
        index: 0,
        thumbnailParentClass: 'eber-common-files-' + this._uid,
        srcname: 'image',
        wname: 'width',
        hname: 'height',
        tname: 'remark',
        shareEl: true,
        shareButtons: []
      },
      showPhotoSwipe: false
    }
  },
  computed: {},
  created () {
    this.vpsoptions.shareButtons = _.clone(this.shareButtons)
    if (_.isEmpty(this.shareButtons)) {
      this.vpsoptions.shareEl = false
    }
  },
  mounted () {},
  beforeDestroy () {},
  watch: {},
  methods: {
    handlePreview (file) {
      let index = _.findIndex(this.files, item => {
        return item[this.keyName] === file[this.keyName]
      })
      this.vpsoptions.index = index
      this.showPhotoSwipe = true
    },
    handleDeleteImage (options) {
      this.$emit('click-delete', options)
    },
    handleSortFiles (file, newIndex, oldIndex) {
      this.$emit('sort-files', file, newIndex, oldIndex)
    },
    handleShareLinkClick (e, target) {
      console.log(e)
      console.log(target)
    }
  }
}
</script>

<template>
  <div class="list-wrap clear">
    <eber-files
      v-if="files.length > 0"
      v-model="files"
      :custom-class="vpsoptions.thumbnailParentClass"
      :handlePreview="handlePreview"
      :disabled="disabled"
      :enable-drag="enableDrag"
      @remove="handleDeleteImage"
      @sort="handleSortFiles"
    ></eber-files>
    <eber-photo-viewer
      v-if="showPhotoSwipe"
      :images="files"
      :show-index="vpsoptions.index"
      @close="showPhotoSwipe=false">
    </eber-photo-viewer>
<!--    <vue-photo-swipe :options="vpsoptions" :images="files" :thumbnailElementSelection="'.' + vpsoptions.thumbnailParentClass + ' .eber-file-list__item'" :show="showPhotoSwipe" @close="showPhotoSwipe=false" @shareLinkClick="handleShareLinkClick"></vue-photo-swipe>-->
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
